import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchAccountOverview } from '../store/actions/account-actions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import Header from './Header';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import PersonalDetails from './PersonalDetails';
import UserAccounts from './UserAccounts';
import PartnerInsights from './PartnerInsights';

const Account = props => {
  const { showUserAccounts, showPartnerAccounts } = useSelector(state =>
    ({
      showUserAccounts:
        state.auth.tokenPayload &&
        state.auth.tokenPayload.scopes &&
        state.auth.tokenPayload.scopes.indexOf('manage:users') > -1,
      showPartnerAccounts:
        state.auth.tokenPayload &&
        state.auth.tokenPayload.scopes &&
        state.auth.tokenPayload.scopes.indexOf('manage:partnerAccounts') > -1,
    }), shallowEqual);


  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAccountOverview());
  });

  return (
    <div className="Account">
      <Header />
      <div className="Account_top">
        <div className="container">
          <h1>Account Overview</h1>
        </div>
      </div>
      <PersonalDetails />
      <div className="Account_divider" />
      {showUserAccounts && <UserAccounts />}
      {showPartnerAccounts && <PartnerInsights />}
      <CopyrightAndVersion />
    </div>
  );
};



Account.propTypes = {
  showUserAccounts: PropTypes.bool,
  showPartnerAccounts: PropTypes.bool,
};

Account.defaultProps = {
  showUserAccounts: false,
  showPartnerAccounts: false,
};


export default Account;
